import { LayoutGrid } from "lucide-react";
import { formatDate } from "@/lib/utils";

interface BlockOverviewProps {
  blockHeight: number;
  blockTime: number;
}

export default function BlockOverview({ blockHeight, blockTime }: BlockOverviewProps) {
  return (
    <div className="flex items-center mb-6">
      <div className="bg-blue-100 dark:bg-blue-900/30 p-3 rounded-lg mr-4">
        <LayoutGrid className="h-8 w-8 text-blue-600 dark:text-blue-400" />
      </div>
      <div>
        <h2 className="text-xl font-bold text-slate-900 dark:text-white">Block #{blockHeight}</h2>
        <p className="text-slate-600 dark:text-gray-400 text-sm">
          <span className="font-medium">Mined:</span> {formatDate(blockTime, "MM/DD/YYYY, HH:mm:ss")}
        </p>
      </div>
    </div>
  );
} 